import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-FunctionStudio",
  "use": "icon-FunctionStudio-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-FunctionStudio\"><path fill=\"#333333\" d=\"M712 504L768 448h192v33.696L928 576h-96l-56 48-64-120zM576 832H384v-32l32-96h88l56-48 64 120-48 56zM0 832v-32L240 128h416v32l-32 96H336l-64 192h365.344L768 704h112v32l-32 96h-151.504l-3.152-1.328L556.64 576H224L128 832H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol